// src/pages/Accounting/Receipts/components/ViewDrawer/DrawerHeader.tsx

import type { ReceiptSource } from "../../types";
import { PALETTE, SOURCE_LABELS } from "../../constants";
import { formatDateLong, formatUploadedAt } from "../../utils";

interface DrawerHeaderProps {
  vendorName: string;
  date: string;
  source: ReceiptSource;
  uploadedAt: string;
  onClose: () => void;
}

export function DrawerHeader({
  vendorName,
  date,
  source,
  uploadedAt,
  onClose,
}: DrawerHeaderProps) {
  return (
    <div
      style={{
        padding: "18px 22px 14px",
        borderBottom: `1px solid ${PALETTE.line}`,
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 12,
      }}
    >
      <div style={{ minWidth: 0 }}>
        <h3
          style={{
            fontSize: 20,
            fontWeight: 700,
            color: PALETTE.ink,
            margin: 0,
            letterSpacing: "-0.01em",
            lineHeight: 1.2,
          }}
        >
          {vendorName || "Unknown vendor"}
        </h3>
        <div
          style={{
            fontSize: 12.5,
            color: PALETTE.ink2,
            marginTop: 4,
            fontWeight: 500,
          }}
        >
          {formatDateLong(date)} &middot; {SOURCE_LABELS[source]} &middot;{" "}
          {formatUploadedAt(uploadedAt)}
        </div>
      </div>
      <button
        type="button"
        onClick={onClose}
        aria-label="Close"
        style={{
          background: "transparent",
          border: 0,
          color: PALETTE.ink2,
          cursor: "pointer",
          fontSize: 22,
          lineHeight: 1,
          padding: 0,
          width: 24,
          height: 24,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        ×
      </button>
    </div>
  );
}